import OverlayPanel from '@/components/shared/OverlayPanel'
import { websiteContent } from '../content'

type ContactPanelProps = {
  isOpen: boolean
  onClose: () => void
}

const submitLikeButtonClasses =
  'inline-flex min-h-[48px] min-w-[110px] appearance-none items-center justify-center rounded-[2px] border-0 !bg-brand-green px-6 py-4 text-center font-archivo text-caption-bold font-bold uppercase leading-[14px] text-brand-greenBright no-underline'

const toTelHref = (rawPhone: string) => {
  const digits = rawPhone.replace(/\D/g, '')
  if (!digits) return 'tel:'
  if (digits.length === 10) return `tel:+1${digits}`
  return `tel:+${digits}`
}

function ContactPanel({ isOpen, onClose }: ContactPanelProps) {
  const { contactPanel } = websiteContent
  const phoneNumber = contactPanel.actionTwo.phoneNumber
  const phoneHref = toTelHref(phoneNumber)

  return (
    <OverlayPanel
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel={contactPanel.ariaLabel}
      className="backdrop-blur-[22px]"
      contentClassName="!h-full !max-w-none !px-0"
      backdropClassName="bg-[#141414]/75 backdrop-blur-[12px]"
      closeButtonClassName="right-[24px] top-[24px] !size-[66px] !bg-gray-medium !text-white hover:scale-100 focus-visible:scale-100 [&>svg]:!size-[24px] md:right-[40px] md:top-[40px]"
    >
      <div className="ml-auto h-full w-full bg-white px-6 pb-10 pt-[104px] text-gray-dark md:w-[31.111vw] md:min-w-[360px] md:max-w-[448px] md:px-7 md:pb-[72px] md:pt-[118px]">
        <div className="flex h-full flex-col">
          <header>
            <h2 className="text-h1-m font-archivo font-extralight text-gray-dark">
              {contactPanel.title}
            </h2>
          </header>

          <div className="mt-10 flex-1 space-y-8 overflow-y-auto pr-1">
            <section className="space-y-4">
              <p className="text-[18px] font-archivo font-medium leading-[26px] text-gray-dark">
                {contactPanel.actionOne.title}
              </p>
              <a
                href={contactPanel.actionOne.url}
                target="_blank"
                rel="noreferrer"
                className={submitLikeButtonClasses}
              >
                {contactPanel.actionOne.buttonLabel}
              </a>
            </section>

            <section className="space-y-4">
              <p className="text-[18px] font-archivo font-medium leading-[26px] text-gray-dark">
                {contactPanel.actionTwo.title}
              </p>
              <a href={phoneHref} className={submitLikeButtonClasses}>
                {contactPanel.actionTwo.buttonLabel}
              </a>
            </section>

            {/* TODO(nxt-phase2): Re-enable the contact form (name/email/company/note + submit) once backend wiring is ready. */}
          </div>
        </div>
      </div>
    </OverlayPanel>
  )
}

export default ContactPanel
